import React from 'react';

import './showcaseSection.css';
import './showcaseSectionMobile.css';

const ShowcaseSection = (props) => {
  const pageContent = props['content'];
  return <section className="showcase" id="showcase">
    {pageContent.map((content, idx) => {
        return <div className="item" key={idx}>
        <div className="media"><img src={content['image']} alt="" /></div>
        <div className="description">
          <div className="title">{content['title']}</div>
          <div className="content">{content['content']}</div>
        </div>
      </div>
    })}
  </section>;
}
export default ShowcaseSection;